export const langEn = {
  header: {
    menu: {
      user: 'User：{{value}}',
      login: 'Login',
      logout: 'Logout',
      member: 'Account',
    },
    landing: {
      company: 'Provider Info.',
      info: 'Contact Us',
    },
  },
  common: {
    close: 'Close',
    cancel: 'Cancel',
    execute: 'Execute',
    edit: 'Edit',
    delete: 'Delete',
    registeredLocations: 'Registered Locations',
    analyzedLocations: 'Analyzed Locations',
    analyzableLocations: 'Analyzable Locations',
    locationName: 'Location Name',
    tagName: 'Tags',
    address: 'Address',
    facility: 'facility name',
    status: 'Status',
    analysis: 'Analyzed',
    analysisInProgress: 'Analysis in Progress',
    analysisFailed: 'Failed (Reanalyze)',
    analyzing: 'Analyze',
    unanalyzed: 'Unanalyzed',

    alert: {
      privacy: 'I agree to the Privacy Policy.',
    },

    button: {
      register: 'Register',
      detail: 'Go to Confirmation',
      send: 'Send',
      edit: 'Edit',
      update: 'Update',
      upload: 'Upload',
      export: 'Export results as CSV file',
      showgraph: 'Show Graph',
      cancel: 'Cancel',
      add: 'Add',
      back: 'Back',
    },

    menu: {
      climateRiskAssessment: 'Climate Risk',
      dashboard: 'Dashboard',
      climate_vision: 'Climate Vision',
      freeDashboard: 'Basic Flood Hazard Map',
      newLocation: 'Locations',
      locations: 'Location list',
      addLocation: 'New Location',
      results: 'Results',
      help: 'Help',
      helpUse: 'How to Use',
      helpDesc: 'Methodology',
      faq: 'FAQ',
      used: 'Terms of use',
      privacy: 'Privacy Policy',
      info: 'Contact Us',
      // ここからリアルタイム洪水側
      realTimePrediction: 'Realtime Flood Prediction',
      predictionMap: 'Prediction map',
      alertSetting: 'Alert settings',
      addAlert: 'Add new alert',
      addNewAlert: 'Add new alert',
      editAlert: 'Edit alert',
      alertList: 'View / Edit',
      alertDetail: 'Alert Detail',
      tooltip: {
        climateVision: "You will be redirected to a different web application for climate risk analysis. You will need to create a separate account from this application to use the service."
      }
    },

    label: {
      locationName: 'Location Name',
      tagName: 'Tag',
      address: 'Address',
      region: 'Country/Region',
      latitude: 'Latitude',
      longitude: 'Longitude',
      assets: 'Asset Value',
      sales: 'Net Sales',
      bldgType: 'Asset Type',
      currency: 'Currency',
      description: 'Description',
      information: 'Information',
      contents: 'Contents',
      yearReturnPeriod: 'Flood Depth (1-in-100 years)',
      currentClimate: 'Current Climate',
      scenarioA: '1.5°C Scenario',
      scenarioB: '2°C Scenario',
      scenarioC: '4°C Scenario',
      floodDepth: 'Flood depth (m)',
      totalImpactWithoutCurrency: 'Total impact',
      totalImpact: 'Total impact (K {{value}})',
      damageToAssets: 'Damage to asset (K {{value}})',
      damageToSales: 'Damage to sales (K {{value}})',
      damageRate: 'Damage rate (%)',
      operatingDays: 'Operating days impacted (days)',
      depthOfFlooding: 'Inundation Depth',
      financialImpact: 'Financial Impact',
      recurrencePeriod: 'Return Period',
      year: 'year',
      scenario: 'Scenario',
      location: 'Location',
      locationInformation: 'Location Information',
      assetHeight: 'Asset',
      netSales: 'Net Sales',
      ThousandsOfYen: 'K {{value}}',
      customer: 'Company Name',
      department: 'Department Name',
      personName: 'Name of person in charge',
      email: 'Email',
      inquiryType: 'Inquiry Type',
      inquiryDetails: 'Inquiry Details',
      accountId: 'Account ID',
      password: 'Password',
      username: 'Name',
      createdAt: 'Account creation date',
      plan: 'Plan',
      free: 'Free',
      effectivedAt: 'Effective date',
      transmittance: 'Transparency',
      backgroundmap: 'background map',
      default: 'Default',
      dark: 'Dark',
      satellite: 'Satellite',
      datasouce: 'Data Souce',
      gaiavision: 'Gaia Vision',
      mlit: 'MLIT',
    },
  },
  schema: {
    require: 'Required.',
    number: 'Specify an integer',
    value: 'Not typed correctly',
    email: 'Please enter correct email address.',
  },
  components: {
    LocationRegisterMap: {
      desc: 'The area in the red frame is the analysis range.',
    },
    floodDepthMeter: {
      overFiveMeters: '2F+ flooded',
      twoToFiveMeters: 'Up to 2F',
      oneToTwoMeters: '1F flooded',
      halfToOneMeter: 'Cars unsafe',
      tenthToHalfMeter: 'Walking difficult',
      openLegend: 'Open flood depth legend',
      closeLegend: 'Close flood depth legend',
      referenceImage: 'Flood depth reference',
    },
  },
  pages: {
    user: {
      title: 'User Information',
    },

    rootMain: {
      title:
        'Climate Change & Flood Risk Analysis: <br/> A Platform for Adaptation and Sustainablity Reporting',
      maintenance: 'Maintenance',
      subTitle: 'How to Use',
      list: {
        itemA: {
          title: '1. Register Locations',
          desc: 'Easy to register locations around the world',
        },
        itemB: {
          title: '2. Run Analysis',
          desc: 'Risk analyzed with state-of-the-art data',
        },
        itemC: {
          title: '3. Display Results',
          desc: 'Display climate risks on a map in an easy-to-understand manner',
        },
      },
    },

    dashboard: {
      title: 'Location Summary',
      subTitle: 'Analysis Results Summary',
      infoTitle: 'Notices',
      tooltip: {
        a: 'Gaia Vision: Gaia Vision’s original simulations using CaMa-Flood, a Global River Hydrodynamics Model developed at the University of Tokyo. Global coverage. CaMa-Flood is a model used by research institutions around the world, including being cited in the IPCC AR6. Gaia Vision runs simulations using originally licensed high-resolution topographic data, and calculates N-year flood risks using extreme value statistical analysis. It is listed in a national guideline in Japan as an example of a product for flood risk assessment (“A Guide to Flood Risk Assessments for Enhanced TCFD Disclosures” by the Ministry of Land, Infrastructure, Transport and Tourism) . The free version shows a 1-in-100-year flood risk only.<br />MLIT: Flood Hazard Map prepared by the Japanese Ministry of Land, Infrastructure, Transport and Tourism and prefectural governments. Only in Japan. 1-in-1000 year flood risk.',
      },
    },

    freeDashboard: {
      title: 'Basic Flood Hazard Map (Low Resolution Version)',
      map: {
        desc: 'For more details, please run the analysis after registering the location.',
      },
    },

    results: {
      title: 'Analysis: Flood Risk',
      subTitleA: 'Risk Assessment Results',
      subTitleB: 'Overall risk map',
      subTitleC: 'Hazard Map',

      tabs: {
        whole: 'All',
        individual: 'Individual',
      },

      button: {
        update: 'Refresh the Results',
      },

      tooltip: {
        a: 'A 1000-year return period indicates a flood that occurs once every 1000 years. The longer it is, the rarer the flood. For more information, see the "Analysis Methodology and Results" page.',
        b: 'The 4℃ scenario is one of the future forecast scenarios related to climate change, referring to a situation where the global average temperature increases in 4℃ compared to pre-industrial levels (1.5℃/2℃ scenarios follow the same concept). The 4℃ scenario is considered to occur if efforts to reduce GHG emissions are insufficient, while the 1.5℃ target aligns with the goals of the Paris Agreement. For more details, please refer to the "Metholodogy" page. In the complimentary version, only the 4℃ scenario is available.',
      },
    },

    rootContact: {
      title: 'Contact Us',
      desc: '',

      const: {
        title: {
          a: { value: 'リスク分析', label: 'risk analysis' },
          b: { value: '情報開示', label: 'Disclosure' },
          c: { value: '防災', label: 'Disaster Prevention' },
          d: {
            value: '気候変動の情報収集',
            label: 'Gathering Climate Change Information',
          },
          e: { value: 'その他', label: 'Other' },
        },
      },

      alert: {
        submit: {
          ok: 'Your inquiry has been sent.',
          ng: 'Your inquiry could not be submitted.',
        },
      },
    },

    appContact: {
      title: 'Contact Us',
      desc: '',

      const: {
        title: {
          a: {
            value: 'アプリケーションの使い方について',
            label: 'How to use the application',
          },
          b: {
            value: '分析結果について',
            label: 'About Analysis Results',
          },
          c: {
            value: '研究・技術について',
            label: 'About Research and Technology',
          },
          d: { value: 'その他', label: 'Other' },
        },
      },

      alert: {
        submit: {
          ok: 'Your inquiry has been sent.',
          ng: 'Your inquiry could not be submitted.',
        },
        content: 'Your inquiry will also be sent to your e-mail address',
      },
    },
    newLocations: {
      title: 'New Location Registration',
      tab: {
        individual: 'Individual Registration',
        bulk: 'CSV batch registration',
      },
      alert: {
        showMap: 'Please enter latitude or longitude.',
        geocode: 'Please enter the correct address or facility name.',
      },
      bulk: {
        desc: 'You can register locations at once from a CSV file.',
        link: '※ Sample CSV File',
        contents: {
          csv: {
            title: 'CSV Input Rules',
            desc: {
              a: 'For following three items, choose from the list specified below. (Red frame in the image)',
              b: 'region (country/region *See Financial Impact Assessment)',
              c: 'bldg_type (Asset type)',
              d: 'currency（currency）',
            },
            label: {
              value: 'value',
              desc: 'desc',
            },
            value: {
              japan: 'Japan',
              asia: 'Asia excluding Japan',
              africa: 'Africa',
              europe: 'Europe',
              northAmerica: 'North America',
              southAmerica: 'South America',
              oceania: 'Oceania',
              other: 'Other',
            },
          },
        },
      },
      form: {
        tag: {
          desc: 'When entering multiple tags, separate them with a single-byte space.',
        },
        address: {
          placeholder: 'Tokyo Station',
          desc: 'You can also search by facility name',
          button: 'Enter latitude and longitude from an address',
        },
        latitude: {
          desc: 'Please enter up to 6 decimal places. North latitude is +, south latitude is -.',
        },
        longitude: {
          desc: 'Please enter up to 6 decimal places. East longitude is +, west longitude is -.',
          button: 'Show Map',
        },
      },
    },

    // 本登録用フォーム
    rootApplication: {
      title: 'Registration form',
      fullName: 'Full name',
      companyName: 'Company name',
      department: 'Department',
      position: 'Position',
      address: 'Address',
      phone: 'Phone number',
      submit: {
        alert: {
          ok: 'Your registration has been completed. The page will automatically transition.',
          ng: 'This form could not be sent',
        },
      },
      button: {
        confirm: 'Go to Confirmation',
        register: 'Register',
        edit: 'Edit',
      },
      termsOfUse: {
        regardedAsAgreement: "Please confirm and agree to the <0>{{termsOfUse}}</0> and <1>{{privacy}}</1> before creating an account. By creating an account, you are considered to have agreed to these terms.",
        termsOfUse: "terms of service",
        privacyPolicy: "privacy policy",
      },
      },

    editLocations: {
      title: 'Edit Location Information',
      alert: {
        showMap: 'Enter latitude or longitude.',
        geocode: 'Enter the correct address or facility name.',
        analysis: '※ If already analyzed, address and location cannot be changed.',
      },
      form: {
        sales: {
          desc: 'If you wish to change assets or sales after the analysis, update the analysis results from the Analysis Results screen after reflecting the changes.',
        },
      },
    },

    locations: {
      title: 'List of Registered Locations',
      allAnalyzable: 'Analyze all',
      newLocations: 'Add new location',
      deleteModal: {
        title: 'Do you want to delete "{{value}}"?',
        desc: 'Once deleted, it cannot be restored.',
      },
      analysisModal: {
        title: 'Do you want to run an analysis for "{{value}}"?',
        desc: '1 credit is consumed.<br />※ Please make sure that the latitude and longitude are correct.',
      },
      analysisAllModal: {
        title: 'Do you want to analyze all unanalyzed locations?',
        desc: 'Credits are consumed.<br />※ Please make sure that the latitude and longitude are correct.',
      },
      analysisStartModal: {
        title: 'Analysis has been initiated.',
      },
      modal: {
        title: 'Analysis is completed.',
        desc: 'Please update the analysis results from the Analysis Results page.',
      },
      tooltip: {
        a: 'Check the location information and run the reanalysis.',
      },
    },

    help: {
      title: 'Help',
      subTitle: {
        a: '1. About Accounts and Plans',
        b: '2. About Analysis and Results',
        c: '3. Others',
      },
      contents: {
        a: {
          q: 'Can I add analysis quota?',
          a: 'Yes, you can buy extra quota. Please contact us through the Contact Us page. We will contact you procedure for changing your plan.',
        },
        b: {
          q: 'I want to change my account password.',
          a: 'Please go to the Contact Us page and tell us that you would like to change your password.',
        },
        c: {
          q: 'Can I log into on multiple devices with same account at the same time?',
          a: 'Currently, it is possible to log into one account with multiple devices.',
        },
        d: {
          q: 'How accurate are the results of this analysis?',
          a: 'Comparison between the results of our hazard maps and the flood areas of past flood events is explained on the explanation page. Actual flood area depends greatly on the amount of rainfall and how it rains, and our hazard maps do not always match.<br/>In addition to this, our hazard maps only cover floods caused by river flooding, and do not cover inland flooding (urban flooding). For details, please refer to the explanation page (Limitations of Analysis).<br/>As stated in the Terms of Use, the analysis results of this application are not absolute and should be used as a reference for risk management and other purposes.',
        },
        e: {
          q: 'I would like to see hazard maps for a wider area.',
          a: 'Please contact us through the Contact Us page to let us know the area and size you would like to see.',
        },
        f: {
          q: 'Is it possible to analyze locations on water, such as rivers and lakes?',
          a: 'Since the current flood hazard maps are for river flood, we have data on the depth of rivers. On the other hand, data for lakes and ponds is still not validated enough. Marine areas are not covered by flood hazard maps.',
        },
        g: {
          q: 'Can we analyze other risks?',
          a: 'We are researching and developing data on storm surge, sea level rise, water stress, etc. If you have a more specific request, please contact us through the Contact Us page.',
        },
      },
    },

    howTo: {
      title: 'How to use the application',
      subTitle: {
        a: 'What is Climate Vision?',
        b: 'Analysis Procedure',
        ba: '1.Registering a location',
        bb: '2.Editing a location',
        bc: '3.Running the analysis',
        bd: '4.Check results',
      },
      contents: {
        aa: 'This is a web application to analyze flood risks around the world. Currently, only river floods can be analyzed.',
        ab: 'Flood risk refers to "the depth of flood and the financial impact on a company or other entity caused by a flood that may occur once every XX years. The "XX years" is referred to as the "return period."',
        ac: 'Risk of once in 10, 100, 1000-year flood is provided.',
        ad: 'Credits are consumed for each analysis run.',
        ae: '1 analysis for 1 location = 1 credit',
        af: 'Access to the system is valid only for the contract period specified in the purchase order.',

        ba: '1. Register a location with "New Location"',
        bb: 'Enter the name, address and description of the location.',
        bc: 'Explanation of the items are as follows:',
        bd: 'Location name: Name of the location used within this system. You may specify any name; name of the building, role, etc.',
        be: 'Tag (optional): Displayed on the list of registered locations page. You can add tags to classify locations. Main business unit in charge, other suitable information is recommended for organizing analysis results. Multiple tags can be set by separating them with a space.',
        bf: 'Address (optional): After entering an address, press the "Enter latitude and longitude from address" button to obtain the latitude and longitude. (This feature uses Google API inside and the location may be inaccurate, so please check the map carefully.)',
        bg: 'Latitude and longitude: Analysis is processed based on latitude and longitude.',
        bh: 'Please enter latitude and longitude to the sixth decimal place.',
        bi: 'Click "Check on map" button after entering latitude and longitude, and a marker appears on the map.',
        bj: 'Latitude and longitude can be adjusted by dragging the marker.',
        bk: 'Sales amount: Enter the sales amount of the location. This is used to evaluate indirect damages (financial damage from suspension of business) in the financial impact assessment. Factory output is one example to estimate the value.',
        bl: 'Assets: Specify amount of the asset in this location. This is used to assess direct damages (damages to asset itself) in the financial impact assessment. The accumulated amount of inventory of each facility is one example.',
        bm: 'Description (optional): Enter a description for internal management purposes, if necessary.',
        bn: 'You may edit some of location information even after analysis, however, "address" and "longitude, latitude" becomes uneditable after analysis.',
        bo: '(New location registration page)',
        bp: 'You can also register multiple locations at once using a CSV file.',
        bq: 'Please refer to the sample file to create a CSV file and upload it from the upload button.',
        br: 'Sample CSV file',
        bs: 'Please enter latitude and longitude to the sixth decimal place.',
        bt: 'Maximum number of locations in one CSV file is 100.',
        bu: 'Please enter the country/region, asset type, and currency from the list. Please refer "CSV Batch Registration" page for explanation.',
        bv: '(CSV batch registration page)',

        ca: '2. You may check, edit, delete the locations registered from "Location list".',
        cb: 'Non-analyzed locations can be edited or deleted.',
        cc: `You may edit some of location information even after analysis, however, "address" and "longitude, latitude" becomes uneditable after analysis. You can't delete the location once it's analyzed.`,
        cd: '(List of registered locations page)',

        da: '3. Press the "Analyze" button on the "Location list" page',
        db: 'In "Registered Locations List" page, green "Analyze" button is displayed for locations that have not been analyzed. Press the button to start analyzing.',
        dc: 'The analysis will take about 20-30 seconds per location.',
        dd: 'The "Analyze" button where the analysis was performed will change to "Analyzing" and then "Analyzed".',
        de: '',

        ea: '4. You can check the result of the analysis from "Analysis Results" page.',
        eb: 'The risks of all the analyzed locations are displayed on the map.',
        ec: 'You can get flood depth and financial impact for flood of once in 10, 100, 1000-year, for each climate scenario.',
        ed: 'The darker the color of the marker, the higher the risk.',
        ee: 'Climate scenarios can be selected from "current climate", "1.5℃ Scenario", "2℃ Scenario" and "4℃ Scenario".',
        ef: '(Analysis results page: Flood depth)',
        eg: 'Choose "Financial Impact" to see extent of the damage, risk in monetary terms which is estimated based on the depth of the flood.',
        eh: 'As with the flood depth, the darker the marker, the higher the risk (higher estimated damage).',
        ei: '(Analysis Results page: Financial Impact Assessment)',
        ej: 'Click "Individual" tab to check hazard map near the analyzed location, damage rate, and number of days of operating impact.',
        ek: '"Hazard map" refers to the distribution of the flood depth displayed on the map for each of once in 10, 100, 1000-year flood.',
        el: 'Area analyzed is a 2km square, the location in the center.',
        em: 'If you require a larger area hazard map, please contact us.',
        en: '(Analysis result page: individual location details)',
        eo: 'All data can be downloaded as a CSV file from the "Export Results as CSV File" button at the bottom of result page. Risk assessment results can be exported in separete files for each location and each return period.',
        ep: 'Use of analysis data is limited to your company and affiliated companies.',
        eq: 'Publicizing analysis result for the purpose of disclosure, TCFD for instance, is the exception.',
        er: 'If you wish to provide or sell the data to third parties, please contact us.',

        es: 'Asset Type: The nature of the building will affect the amount of damage. Choose from six types that most closely resemble the nature of the building or land you are analyzing.',
      },
    },

    // ここからリアルタイム
    predictionMap: {
      showPins: 'Show observation pins on the map',
      fld_prediction: 'Flood ',
      precipitation_pred: 'Precipitation',
      urlFetching: 'Loading flood predicion map ',     
      // loadFailed: 'Due to current system maintenance, data retrieval has been temporarily suspended. We apologize for any inconvenience this may cause and appreciate your patience until the completion of the maintenance.',
      loadFailed: 'The operation has been suspended since November due to the non-runoff season, and will be resumed in late May. You can check the forecast data from the past by clicking “Select Analysis Time”.',
      contact: "Please contact the management \n if you have any concerns or issues",
      fetching: 'Fetching latest data...',
      frameLoading: 'Loading data for this time...',
      frameError: 'Failed to load data for this time',
      frameDisplaying: ' (showing {{date}})',
      frameRetry: 'Retry',
      frameFallback: 'The latest analysis is not available yet. Showing the analysis at {{date}}.',
      timestamp: 'At {{date}}',
      tbd: "（To be implemented in the future）",
      calculatedAt: 'Based on analysis at <0>{{date}}</0>',
      chooseCalculatedTime:"Choose calulated time",
      timeInterval:"data increment: <0>{{interval}}</0> hours",
      settings:{
      dataSetting:"Data settings",
      dataTimeIncrement:"Interval",
      calculationTime:"Calculated at ",
      timeIntervalOption: 'every {{interval}} hours',
      cancel:"cancel",
      saveSettings:"save",
      selectedTimeNotExist:"Data for the selected calculated time don't exist",
      hourDesc: "{{increment}}-hour forecast",
      },
      paymentModal: {
        title: 'Subscription required',
        alert:"Registering alerts",
        map:"Future prediction map",
        featureIsLimited: ' is available when you apply for paid plan.',
        paidPlan: "Paid plan",
        freePlan: "Free plan",
        descriptionFree: "You can view the simulation result of past flood events.",
        descriptionPaid: "You can receive the latest forecast results and alert notifications.",
        past: "Past",
        present:"Present",
        prediction: "Prediction",
        notification:"Notification",
        inquiry: 'Inquiry page can be found',
        here:" here",
    },
      stationDetail: {
        locationInfo: 'Location information',
        riverForecast: 'River water level forecast',
        pastOnly: 'Past only',
        pastAndForecast: 'Past and forecast',
        latestForecastWaterLevel: 'Latest forecast water level',
        peakForecastWaterLevel: 'Peak forecast water level over next {{hours}} hours',
        observedWaterLevel: 'Observed water level',
        thresholds: {
          floodWarning: 'Flood caution level',
          evacuation: 'Evacuation advisory level',
          danger: 'Flood danger level',
          planned: 'Planned high water level',
        },
        chart: {
          pastEstimate: 'Past estimate',
          forecast: 'Forecast',
          latestTime: 'Latest time',
          riverWaterLevelAxis: 'River water level [m]',
        },
      },
      registeredInfo: 'Registered info',
    },
    // JMAの警報
    jmaAlerts: {
      title: 'Warnings',
      detail: 'Detail',
      currentlyPaused: 'Only JMA announcements related to heavy rain and flooding are shown',
      publisher: 'Issued by JMA',
      noInformation: 'No information',
      prefectureFallback: 'Prefecture',
      heavyRain: 'Heavy Rain',
      flood: 'Flood',
      cleared: 'Cleared',
      level: 'Level {{level}}',
      legend: {
        level5: 'Level 5\nEmergency Warning',
        level4: 'Level 4\nDanger Warning',
        level3: 'Level 3\nWarning',
        level2: 'Level 2\nAdvisory',
      },
      legendWarning: {
        level5: 'Emergency Warning',
        level4: 'Danger Warning',
        level3: 'Warning',
        level2: 'Advisory',
      },
    },

    // ここからアラート
    alerts: {
    addByAddress: 'By address',
    addByArea: 'By selecting area',
    addByRiverLevel: 'River Level: Register by Point',
      areaName: 'area / name',
      areaSample: 'factory name, company name, etc.',
      area:{
        topLeftLatLon: "North West", 
        bottomRightLatLon: "South East", 
      },
      addNewAlert:{
        enterAddress: "Enter addres",
        selectOnMap:"Select on map",
        editAreaName: "Edit area name",
        otherSettings: "Other settings",
        shareInClient: "Share within client", 
        desc: "By registering a point or area, you'll receive notifications (e.g. by e-mail) when the specified conditions are met.",
      },
      centerAddress: 'Selected area',
      selectArea: 'Select area in map',
      address: 'Address',
      numOfConditions: 'Conditions',
      pointOrArea: 'Point / Area',
      asPoint: 'point',
      asArea: 'area',
      variable: 'variable',
      floodDepth: 'floodDepth',
      waterLevel: 'waterLevel',
      addressSample: 'Some address',
      searchToMove: 'Search to move',
      longitude: 'Longitude',
      latitude: 'Latitude',
      inputManually: 'Set latitude & longitude manually',
      goNext: 'Next（Alert condition）',
      tooltip: {
        areaName:
          'This label is for when you record a location. It does not need to match the actual place name.',
        addressInput: "You may enter your address approximately. The map on the right will move according to the address entered, allowing you to select the desired location for the alert on the map.",
        clickOnMap: "You can click the map to the right to set places for alert.",
        shareWithClientTooltip: "If you check this box, this alert will be shared with all users in the same client. If you do not check this box, the alert will only be visible to you.",
      },
      areaNameSample: 'my house / my factory ',
      invalidLatLon: 'The value of the latitude or longitude is invalid',
    },
    alertList: {
      registered: 'Registered alerts',
      conditionList: 'Alert conditions list',
      conditionUnregistered: 'Conditions for this alert have yet to be registered.',

      selectAlert: 'Choose alert.',

      condition: 'Condition',
      conditionSetter: {
        variable: 'variable',
        floodForecast: 'flood depth',
        precipitation: 'precipitation',
        waterLevel: 'river level',
        timerange: 'time',
        threshold: 'threshold',
        notificationMethod: 'notification',
        mail: 'mail',
        slack: 'Slack',
        in: 'in',
        hours: 'hours gets more than',
        cm: 'cm',
        updateComplete:"update completed",
        updateFailed:"Update failed",
        validationMsg:{
          timeRange: ' must be 36 or less',
          floodForecast: ' must be {{thresh}} or more',
          precipitation: ' must be {{thresh}} or more',
          waterLevel: ' must be {{thresh}} or more',
        },
      },
      tooltip: {
        notification:
          'mail: notification will be sent to the email address registered with this system.',
      },
      addCondition: 'Add',
      save: 'この内容で保存',
    },
  },
};
